import Rebase from 're-base'

export default Rebase.createClass('https://zelda.firebaseio.com')



/** WEBPACK FOOTER **
 ** ./client/app/lib/base.js
 **/